export const colors = {
  gray: "#6A6A6A",
  green: "#50938A",
  red: "#ED4C05",
  lightGray: "#CCCCCC",
  lightGreen: "#AFD095",
  blue: "#729FCF",
  lightBlue: "#B5C7DC",
};
